// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3XVoS","list":"PatternAutocomplete_list__fMVYQ"};